import { useEffect, useRef, useState } from 'react'

export interface UseContentBriefBlockStateProps {
  comment?: string
}

export interface UseContentBriefBlockStateReturn {
  isEditing: boolean
  setIsEditing: (value: boolean) => void
  draftComment: string
  setDraftComment: (value: string) => void
  textareaRef: React.RefObject<HTMLTextAreaElement | null>
  hasComment: boolean
}

export const useContentBriefBlockState = ({
  comment,
}: UseContentBriefBlockStateProps): UseContentBriefBlockStateReturn => {
  const [isEditing, setIsEditing] = useState(false)
  const [draftComment, setDraftComment] = useState(comment ?? '')
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const hasComment = Boolean(comment)

  useEffect(() => {
    if (isEditing && textareaRef.current) {
      textareaRef.current.focus()
    }
  }, [isEditing])

  return {
    isEditing,
    setIsEditing,
    draftComment,
    setDraftComment,
    textareaRef,
    hasComment,
  }
}
